/* eslint-disable max-len */
import axios from 'axios';

import TradeOrganization from '../tradeOrganization/TradeOrganization.vue';
import ViewImgComponent from '../components/view-img.vue';
import FileUploader from '../components/file-uploader.vue';
import Hint from '../components/Hint.vue';

const defaultImage = { base64: '', name: '', filename: '', url: '' };
const defaultPosition = {
  code: null,
  model: null,
  series: null,
  product_id: null,
  barcode_id: null,
  quantity: 1,
  house_photo: { ...defaultImage },
  model_photo: { ...defaultImage },
  guarantee_photo: { ...defaultImage },
};

export default {
  props: ['action_id', 'id'],
  components: { TradeOrganization, ViewImgComponent, FileUploader, Hint },
  data() {
    return {
      tables: {
        headers: [
          { text: 'Фото', value: 'photoUrl', sortable: false, align: 'left' },
          { text: 'Название', value: 'name', sortable: false, align: 'left' },
          { text: 'Кол-во', value: 'quantity', sortable: false, align: 'center' },
          { text: '', value: '', sortable: false, align: '' },
        ],
      },
      saleID: this.$props.id,
      actionID: this.$props.action_id,
      showHistory: false,
      address: '',
      address_data: {},
      regions: [],
      cities: [],
      city_id: null,
      region_id: null,
      menu1: '',
      menu2: '',
      suggestions: [],
      sold_on: '',
      sold_on_local: '',
      date_setup: '',
      date_setup_local: '',
      productsSelected: [],
      product: '',
      number: '',
      dateModal: false,
      bonuses: {
        total: 0,
        plan: null,
        fact: 0,
        unit: '',
      },
      defaultImage: { ...defaultImage },
      defaultPosition: { ...defaultPosition },
      positions: [{ ...defaultPosition }],
      tradeOrganizationId: null,
      tradeOrganization: {},
      valid: false,
      installation_data: [],
      installation_models: [],
      modelIsBlocked: true,
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
    };
  },
  watch: {
    sold_on(val) {
      this.sold_on_local = val && this.formatDate(val);
    },
    date_setup(val) {
      this.date_setup_local = val && this.formatDate(val);
    },
    address_data(val) {
      this.region_id = null;
      this.city_id = null;
      if (val && this.regions) {
        if (val.region_fias_id) {
          this.regions.forEach((item) => {
            if (item.fias_id === val.region_fias_id) {
              this.region_id = item.id;
            }
          });
        }
        if (!this.region_id && val.region_kladr_id) {
          this.regions.forEach((item) => {
            if (item.kladr_id === val.region_kladr_id) {
              this.region_id = item.id;
            }
          });
        }
      }
    },
    async region_id(val) {
      if (!val) {
        return;
      }
      await this.getCities();
      if (this.address_data && this.cities) {
        this.cities.forEach((item) => {
          if (item.fias_id === this.address_data.city_fias_id) {
            this.city_id = item.id;
          }
        });

        if (!this.city_id && this.address_data.city_kladr_id) {
          this.regions.forEach((item) => {
            if (item.kladr_id === this.address_data.city_kladr_id) {
              this.city_id = item.id;
            }
          });
        }
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    action() {
      return this.$store.state.sales.action;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    sale() {
      return this.$store.state.sales.sale;
    },
    groups() {
      return this.$store.state.sales.groups;
    },
    productsList() {
      return this.action && this.action.products.length
        && this.action.products.map(item => item.name);
    },
    products() {
      const { action } = this.$store.state.sales;
      if (action !== null) {
        return action.products;
      }
      return [];
    },
    bonuses_formula() {
      if (this.$store.state.sales.action != null) {
        return this.$store.state.sales.action.bonuses_formula;
      }
      return 1;
    },

    validationForm() {
      return this.tradeOrganizationId && !!this.address && this.positions.every(el => (
        (el.house_photo.base64 || el.house_photo.url)
        && (el.model_photo.base64 || el.model_photo.url)
        && (el.guarantee_photo.base64 || el.guarantee_photo.url)));
    },
    isEditable() {
      return this.saleID === 'null' || !!(
        this.sale && this.sale.action.is_actual
        && (this.sale.status === 'adminReview'
          || this.sale.status === 'draft'
          || this.sale.status === 'redo'
        )
      );
    },
    descriptions() {
      return this.$store.state.sales.descriptions;
    },
    limit() {
      return this.$store.state.sales.limit;
    },
    allowAddPosition() {
      if (!this.limit || !this.limit?.limit) {
        return true;
      }

      const existSalePositionsCount = this.sale ? this.sale.positions.length : 0;
      return this.limit.allowCount > (this.positions.length - existSalePositionsCount);
    },
  },
  methods: {
    addPosition() {
      this.positions = [...this.positions, { ...this.defaultPosition }];
    },
    deletePosition(idx) {
      this.positions.splice(idx, 1);
    },
    getRegions() {
      const app = this;
      app.isLoading = true;
      return app.$store.getters.ax.post('local-location/api/regions/list')
        .then((response) => {
          if (response.data.regions !== null && Array.isArray(response.data.regions)
            && response.data.regions.length) {
            app.regions = response.data.regions;
          }
        }).catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    getCities() {
      const app = this;
      app.isLoading = true;
      return app.$store.getters.ax.post('local-location/api/cities/list', { region_id: this.region_id })
        .then((response) => {
          if (response.data.cities !== null && Array.isArray(response.data.cities)
            && response.data.cities.length) {
            app.cities = response.data.cities;
          }
        }).catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [onlyDate] = date.split(' ');
      return onlyDate;
    },
    selectedTradeOrganization(tradeOrganization) {
      this.tradeOrganizationId = tradeOrganization ? tradeOrganization.id : null;
    },
    /** Подсчет суммы баллов за добавленные продукты (с помощью бэкенд обработки данных). */
    CalculateSum() {
      const app = this;
      const sale = {
        profile_id: app.user.profile_id,
        action_id: app.actionID,
        positions: app.productsSelected.map(item => ({
          product_id: item.id,
          quantity: item.quantity,
        })),
      };

      if (app.saleID !== 'null') {
        sale.sale_id = app.sale.id;
        sale.action_id = app.sale.action_id;
      }

      app.$store.getters.axl.post('sales/api/bonus/calculate', sale)
        .then((response) => {
          this.bonuses = response.data.bonuses;
        })
        .catch(error => app.$store.dispatch('HandleError', error));
    },
    /** Открыть диалог прикрепления фото */
    SetPhoto(e, idx, key) {
      const position = this.positions[idx];
      position[key] = e;
      this.positions.splice(idx, 1, position);
    },
    /**
     * Удаление документа из списка прикрепленных файлов.
     * @param idx номер в списке документов.
     */
    RemoveImg(idx, key) {
      const position = this.positions[idx];
      position[key] = { ...this.defaultImage };
      this.positions.splice(idx, 1, position);
    },
    /**
     * Установка предзагруженных значений при редактировании продажи.
     */
    setDataPreload() {
      const app = this;
      if (app.sale) {
        app.number = app.sale.number;
        app.tradeOrganizationId = app.sale.trade_organization_id;
        app.tradeOrganization = app.sale.tradeOrganization;

        app.date_setup = app.parseDate(app.sale.date_setup);
        app.sold_on = app.parseDate(app.sale.sold_on);
        app.date_setup_local = app.formatDate(app.date_setup);
        app.sold_on_local = app.formatDate(app.sold_on);
        app.region_id = app.sale.region_id;
        app.city_id = app.sale.city_id;

        app.address = app.sale.address;

        const positions = app.sale.positions.map(el => ({
          id: el.id,
          code: el.product ? el.product.parent_name : null,
          model: el.product ? el.product.name : null,
          series: el.series,
          product_id: el.product_id,
          barcode_id: el.barcode_id,
          quantity: 1,
          guarantee_photo: { ...this.defaultImage, ...el.guarantee_photo },
          model_photo: { ...this.defaultImage, ...el.model_photo },
          house_photo: { ...this.defaultImage, ...el.house_photo },
        }));

        app.positions = positions;
      }
    },
    /**
     * Метод добавления новой продажи.
     */
    onSubmit() {
      const app = this;
      let restURL = 'sales/api/sale/create';

      const sale = {
        profile_id: app.user.profile_id,
        number: app.number,
        sold_on_local: this.sold_on_local,
        action_id: app.actionID,
        date_setup_local: this.date_setup_local,
        address: this.address,
        trade_organization_id: this.tradeOrganizationId,
        positions: this.positions,
        city_id: this.city_id,
        region_id: this.region_id,
        register_from: 'web',
      };

      if (app.saleID !== 'null') {
        restURL = 'sales/api/sale/update';
        sale.sale_id = app.sale.id;
        sale.action_id = app.sale.action_id;
      }

      app.$store.getters.axl.post(restURL, sale)
        .then((response) => {
          const message = response.data?.msg ?? 'Монтаж отправлен на проверку';
          app.$router.push('/sales/');
          app.$store.dispatch('ShowInfo', message);
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    AutocompleteSelect(item) {
      this.region_id = null;
      this.city_id = null;
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.address_data = sug.data;
          document.getElementById('form-address').focus();
        }
      });
    },
    /** Получение товаров и баркодов по серийному номеру в поле автокомплита */
    AutocompleteSearchInstallation(queryString, cb, idx) {
      const app = this;
      app.isLoading = true;
      app.positions[idx].code = null;
      app.positions[idx].model = null;
      app.positions[idx].barcode_id = null;
      app.positions[idx].product_id = null;
      app.installation_data[idx] = [];
      return app.$store.getters.ax.post('sales/api/sale/get-products-by-action', {
        series: queryString,
        action_id: this.actionID,
        type: 'barcode',
      })
        .then(({ data: { products } }) => {
          if (products && Array.isArray(products) && products.length) {
            this.modelIsBlocked = true;
            app.installation_data[idx] = products;
            cb(products.map(item => ({
              ...item,
              value: item.barcode.series,
              text: item.barcode.series,
            })));
            /**
             * ToDo: Тут проблема. При вводе данных например 224848 бэк находит только один товар с номером 22482248
             * и так как это единственно найденый товар сразу подставляет его в поле, что не очень ожидают юзеры
             * я пока отключил эту подстановку единственного найденного варианта, наверное надо на бэке сделать
             * поиск по точному совпадению или вообще убрать подстановку единственного найденного продукта
             */
            // products.length === 1 && this.AutocompleteSelectInstallation({
            //   value: products[0].barcode.series,
            //   text: products[0].barcode.series,
            // }, idx);
          } else if (products && Array.isArray(products) && !products.length) {
            this.modelIsBlocked = false;
            cb([]);
          } else {
            cb([]);
          }
        }).catch((error) => {
          app.$store.dispatch('HandleError', error);
          cb([]);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    AutocompleteSelectInstallation(item, idx) {
      this.installation_data[idx].forEach((sug) => {
        if (sug.barcode.series === item.value) {
          const items = this.positions;
          items[idx] = {
            ...this.positions[idx],
            series: sug.barcode.series,
            model: sug.product.name,
            code: sug.product.parent_name,
            product_id: sug.product.id,
            barcode_id: sug.barcode.id,
            quantity: 1,
          };
          this.positions = [...items];
        }
      });
    },
    /** Получение товаров и баркодов по серийному номеру в поле автокомплита */
    AutocompleteSearchModel(name, cb, idx) {
      const app = this;
      app.isLoading = true;
      app.positions[idx].barcode_id = null;
      app.positions[idx].product_id = null;
      app.positions[idx].code = null;
      app.installation_models[idx] = [];
      return app.$store.getters.ax.post('sales/api/sale/get-models-list', { name, action_id: app.actionID })
        .then(({ data: { models } }) => {
          app.installation_models[idx] = models || [];
          if (models && Array.isArray(models) && models.length) {
            cb(models.map(item => ({
              value: item.name,
              text: `${models[0].name} (SKU: ${item.code})`,
            })));
          } else {
            cb([]);
          }
        }).catch((error) => {
          app.$store.dispatch('HandleError', error);
          cb([]);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    AutocompleteSelectModel(item, idx) {
      this.installation_models[idx].forEach((m) => {
        if (m.name === item.value) {
          this.positions[idx] = {
            ...this.positions[idx],
            model: item.value,
            code: m.parent_name,
            quantity: 1,
            product_id: m.id,
          };

          this.positions = [...this.positions];
          document.getElementById('form-model').focus();
        }
      });
    },
    ChangeModel(idx) {
      this.positions[idx].code = null;
    },
  },
  created() {
    if (this.actionID !== 'null') {
      this.$store.dispatch('sales/GetAction', {
        action_id: +this.actionID,
      });
    }
    if (this.saleID !== 'null') {
      this.$store.dispatch('sales/GetSale', +this.saleID)
        .then((res) => {
          this.$store.dispatch('sales/GetAction', {
            action_id: res.action.id,
            noClearSale: true,
          });
        });
    }
  },
  mounted() {
    if (this.saleID !== 'null') {
      this.setDataPreload();
    }
    this.getRegions();
    this.$store.dispatch('sales/GetSaleDescriptions');
    this.$store.dispatch('sales/GetSaleLimit', { profile_id: this.user.profile_id, sale_id: this.saleID ?? null });
  },
};
